import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 60000,
});

let tokenGetter = () => null;
export const setTokenGetter = (fn) => { tokenGetter = fn; };

api.interceptors.request.use((cfg) => {
  const t = tokenGetter();
  if (t) cfg.headers['Authorization'] = `Bearer ${t}`;
  return cfg;
});

export const parseErr = (e) => {
  if (e?.response?.data?.detail) {
    if (typeof e.response.data.detail === 'string') return e.response.data.detail;
    try { return JSON.stringify(e.response.data.detail); } catch { return 'Error'; }
  }
  return e?.message || 'Request failed';
};
